import Commons from '../../Services/Common/Common';

/**
 * 외부 참여자 서명 (M_EXT_SIGN) — 회의록 참석자 서명과 동일 API
 */
export const M_EXT_SIGN_Schema = {
  mapper: {
    /** useSearch2 → GetMetBasic01R2 (상세 참석자 C) SP_SUB_BASIC_03_R4 */
    search2: {
      Chaebun: (ctx) => Commons.EncryptAES(ctx.chaebun ?? '') || '',
      UserId: (ctx) => Commons.EncryptAES('EXT') || '',
    },
    /** useSearch3 → GetMetBasic01R3 (상세 참석자 I) SP_SAC_BASIC_R4 */
    search3: {
      Chaebun: (ctx) => Commons.EncryptAES(ctx.chaebun ?? '') || '',
      UserId: (ctx) => Commons.EncryptAES('EXT') || '',
    },
    /** useSave2 → SaveMetBasic01U2 (참석자 서명 C) SP_SUB_BASIC_03_U4 */
    save2: {
      Chaebun: (ctx) => Commons.EncryptAES(ctx.chaebun ?? '') || '',
      CheckYn: (ctx) => Commons.EncryptAES(ctx.checkYn ?? 'Y') || '',
      FileName: (ctx) => Commons.EncryptAES(ctx.fileName ?? '') || '',
      FilePath: (ctx) => Commons.EncryptAES(ctx.filePath ?? '') || '',
      Tel: (ctx) => Commons.EncryptAES(ctx.tel ?? '') || '',
      UserId: (ctx) => Commons.EncryptAES('EXT') || '',
    },
    /** useSave3 → SaveMetBasic01U3 (참석자 서명 I) SP_SAC_BASIC_U6 */
    save3: {
      Chaebun: (ctx) => Commons.EncryptAES(ctx.chaebun ?? '') || '',
      CheckYn: (ctx) => Commons.EncryptAES(ctx.checkYn ?? 'Y') || '',
      FileName: (ctx) => Commons.EncryptAES(ctx.fileName ?? '') || '',
      FilePath: (ctx) => Commons.EncryptAES(ctx.filePath ?? '') || '',
      Tel: (ctx) => Commons.EncryptAES(ctx.tel ?? '') || '',
      UserId: (ctx) => Commons.EncryptAES('EXT') || '',
    },
  },
};
